import {
  PropsWithChildren,
  useContext
} from "react";
import dynamic from 'next/dynamic';
// import HeaderPayment from "./HeaderPayment";
// import TotalCart from "../Cart/TotalCart";
import PaymentContext from "../../store/PaymentContext";
import { useRouter } from "next/router";
const DynamicHeaderPayment = dynamic(() => import('./HeaderPayment'));
const DynamicTotalCart = dynamic(() => import('../Cart/TotalCart'));

type TLayoutProps = PropsWithChildren & {
  className?: string;
  hasFooter?: boolean;
};

const LayoutPayment = ({
  children,
  className,
  hasFooter = true,
}: TLayoutProps) => {
  const { currentStep, setSpinLoading, rentCarts, sellCarts, isMobile } =
    useContext(PaymentContext);
  const router = useRouter();

  let step = 1;
  switch (router.pathname) {
    case "/checkout":
      step = 2;
      break;
    case "/order-success":
      step = 3;
      break;
  }

  const height = () => {
    if (step == 1 && (rentCarts?.length > 0 || sellCarts?.length > 0)) {
      return isMobile ? "7.5rem" : "0rem";
    }

    if (step == 2 && isMobile) {
      return "0rem";
    }

    return "5rem";
  };

  return (
    <main className={className} style={{marginTop: "64px"}}>
      <DynamicHeaderPayment />
      <div
        style={{ height: `calc(100vh - ${height()})` }}
        className='overflow-y-auto'
      >
        {children}
      </div>
      {hasFooter &&
        step == 1 &&
        (rentCarts?.length > 0 || sellCarts?.length > 0) && (
          <DynamicTotalCart setLoading={setSpinLoading} />
        )}
    </main>
  );
};

export default LayoutPayment;
